import { SvgIcon } from '@mui/material';

export function CheckCircle() {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12ZM7.56095 11.0902C7.19971 10.729 6.61404 10.729 6.2528 11.0902C5.89157 11.4514 5.89157 12.0371 6.2528 12.3983L9.12135 15.2669C9.87311 16.0186 11.092 16.0186 11.8437 15.2669L17.7472 9.36339C18.1084 9.00216 18.1084 8.41648 17.7472 8.05524C17.386 7.69401 16.8003 7.69401 16.4391 8.05524C15.9082 8.58608 10.5156 14 10.5156 14L7.56095 11.0902Z"
        fill="#32BB78"
      />
    </SvgIcon>
  );
}
